import React, {FC, useState} from 'react';

import './index.scss';
import UiInput from "../../../../../modules/ui/ui-input/ui-input";
import IconBtn from "../../../../../modules/icon-btn/icon-btn";
import UiTextarea from "../../../../../modules/ui/ui-textarea/ui-textarea";
import InfoLabel from "../../../../../components/InfoLabel";
import Tooltip from "../../../../../modules/tooltip";



const DocumentsInfoTab: FC = () => {

  const [trxnData, setTrxnData] = useState("");
  const [resultText, setResultText] = useState("Здесь будет выведен результат расшифровки");

  // const uploadFile = async (file: File, type: COMPANY_UPLOAD_DOC_TYPE) => {
  //   if (file.size <= THREE_MB) {
  //     if (file.type === 'application/pdf') {
  //       dispatch(
  //         uploadProfileDoc({
  //           doc: file,
  //           type,
  //         })
  //       );
  //     } else {
  //       dispatch(setPush({ message: UPLOAD_DOCS_ERROR.FORMAT, type: 'error' }));
  //     }
  //   } else {
  //     dispatch(setPush({ message: UPLOAD_DOCS_ERROR.SIZE, type: 'error' }));
  //   }
  // };

  const Web3 = require('web3');
  const txDecoder = require('ethereum-tx-decoder');
  const web3 = new Web3();

  const decodeMsg = (bytes: any) => {
    let signature = bytes.slice(0, 10);
    let args = bytes.slice(10);
    let result;

    switch (signature) {
      case 'xxxxxx': //Multisig
        console.log('smart contract function name: createTx')
        result = web3.eth.abi.decodeParameters([
          {
            type: 'uint256',
            name: '_id'
          },
          {
            type: 'address',
            name: '_to'
          },
          {
            type: 'uint256',
            name: '_value'
          },
          {
            type: 'bytes',
            name: '_msgData'
          }
        ], args);
        console.log(result);
        break;
      case '0x3a988822':
        console.log('smart contract function name: issueToken')
        result = web3.eth.abi.decodeParameters([
          {
            type: 'string',
            name: '_tokenName'
          },
          {
            type: 'uint64',
            name: '_number'
          },
          {
            type: 'uint64',
            name: '_date'
          },
          {
            type: 'uint64',
            name: '_issuerId'
          },
          {
            type: 'uint64',
            name: '_recipientId'
          },
          {
            type: 'string',
            name: '_agreementChecksum'
          },
          {
            type: 'uint256',
            name: '_initialValue'
          },
          {
            type: 'uint256',
            name: '_tokenCount'
          },
          {
            type: 'uint256',
            name: '_tokenPrice'
          },
          {
            type: 'uint256',
            name: '_redeemDate'
          }
        ], args);
        setResultText(JSON.stringify(result, null, '\t'));
        break;

      case '0x1e728b10':
        console.log('smart contract function name: redeemOffer')
        result = web3.eth.abi.decodeParameters([
          {
            type: 'uint256',
            name: '_offerID'
          },
          {
            type: 'uint64',
            name: '_issueNumber'
          },
          {
            type: 'uint64',
            name: '_holderID'
          },
          {
            type: 'uint256',
            name: '_qty'
          },
          {
            type: 'string',
            name: '_comment'
          }
        ], args);
        setResultText(JSON.stringify(result, null, '\t'));
        break;
      case '0xdb83e9fd':
        console.log('smart contract function name: issueToken')
        result = web3.eth.abi.decodeParameters([
          {
            type: 'uint256',
            name: '_offerID'
          },
          {
            type: 'uint64',
            name: '_issueNumber'
          },
          {
            type: 'uint64',
            name: '_holderID'
          },
          {
            type: 'uint256',
            name: '_qty'
          },
          {
            type: 'string',
            name: '_comment'
          },
          {
            type: 'bool',
            name: 'hold'
          }
        ], args);
        setResultText(JSON.stringify(result, null, '\t'));
        break;
      default:
        setResultText('Некорректные данные');
        break;
    }
  }

  const decodeRawData = (data: any) => {
    let decodedTx = txDecoder.decodeTx(data);
    decodedTx.hash = web3.utils.sha3(data);
    decodedTx.from = web3.eth.accounts.recoverTransaction(data);
    setResultText(JSON.stringify(decodedTx, null, '\t'));
  }

  const handleParseResult = () => {
    setResultText(trxnData);
    try {
      if (trxnData.startsWith("0xf9")) {
        decodeRawData(trxnData);
      } else {
        decodeMsg(trxnData);
      }
    } catch (e) {

    }

  };

  return (
    <div className="form-profile-utils">
      <h3>Расшифровка транзакции</h3>
      <div className="flex justify-end">
        <UiInput
          value={trxnData}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setTrxnData(e.target.value)
          }
          label="Raw Transaction Data"
          name="rawData"
        />
      </div>
      <div className="flex justify">
        <IconBtn
          title="Расшифровать"
          outlined
          disabled={!trxnData}
          onClick={handleParseResult}
        />
      </div>
      <br/>
      <div className="flex justify">
        <UiTextarea
          disabled
          className="textarea"
          id="massage"
          name="massage"
          value={resultText}
        >
          {resultText}
        </UiTextarea>
      </div>
      <br/>
      <Tooltip
        title={
          <p>
            Работа с транзакциями осуществляется с помощью библиотеки {' '}
            <a
              href="https://web3js.readthedocs.io/en/v1.2.11/web3-eth-abi.html"
              target="_blank"
              rel="noreferrer"
            >
              web3js
            </a>
            {' '} и с использованием сигнатур смарт-контракта.
            <br/>
            С методами проверки адреса из подписи можно ознакомиться на официальном сайте в разделе {' '}
            <a
              href="https://web3js.readthedocs.io/en/v1.2.11/web3-eth-accounts.html"
              target="_blank"
              rel="noreferrer"
            >
              web3.eth.accounts
            </a>
            .
          </p>
        }
        placement={'top-start'}
        isCloseClick
      >
        <div className="check-sign">
          <InfoLabel text="Подробнее про методы расшифровки" />
        </div>
      </Tooltip>
    </div>
  );
};

export default DocumentsInfoTab;
